import Vue from 'vue'
import api from '@/services/api'

Vue.prototype.$http = api.axios

export default api
